var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCardNotActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.8335 7.8C3.8335 7.05739 4.11796 6.3452 4.62431 5.8201C5.13066 5.295 5.81741 5 6.5335 5H19.1335C19.8496 5 20.5363 5.295 21.0427 5.8201C21.549 6.3452 21.8335 7.05739 21.8335 7.8C21.8335 8.31547 21.4156 8.73333 20.9002 8.73333H4.76683C4.25136 8.73333 3.8335 8.31547 3.8335 7.8ZM4.8335 9.66667C4.28121 9.66667 3.8335 10.1144 3.8335 10.6667V16.2C3.8335 16.9426 4.11796 17.6548 4.62431 18.1799C5.13066 18.705 5.81741 19 6.5335 19H19.1335C19.8496 19 20.5363 18.705 21.0427 18.1799C21.549 17.6548 21.8335 16.9426 21.8335 16.2V10.6667C21.8335 10.1144 21.3858 9.66667 20.8335 9.66667H4.8335ZM8.3335 11.5333C8.0948 11.5333 7.86588 11.6317 7.6971 11.8067C7.52832 11.9817 7.4335 12.2191 7.4335 12.4667C7.4335 12.7142 7.52832 12.9516 7.6971 13.1266C7.86588 13.3017 8.0948 13.4 8.3335 13.4H12.8335C13.0722 13.4 13.3011 13.3017 13.4699 13.1266C13.6387 12.9516 13.7335 12.7142 13.7335 12.4667C13.7335 12.2191 13.6387 11.9817 13.4699 11.8067C13.3011 11.6317 13.0722 11.5333 12.8335 11.5333H8.3335Z",
    fill: "white",
    fillOpacity: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCardNotActive);
export default __webpack_public_path__ + "static/media/icon_card_notActive.4c23c9b3893bec09dc02e18eda0b099f.svg";
export { ForwardRef as ReactComponent };